import { RRIInputOption } from '../../../form-inputs/public-api';

export interface RRIFilterOption<T> extends RRIInputOption<T> {}
